import React from 'react';
import styled from 'styled-components';


const NextPageLink = styled.a`
  background-color: #${props => props.color};
  color: #fff;
  width: calc(100% - 16px);
  cursor: pointer;
  padding: 4px 8px;
  font-weight: 900;
  font-size: 8vw;
  display: flex;
  align-items: center;
  margin-top: 37px;
`;

const NextPageLinkText = styled.span`
  flex-grow: 1;
`;

const NextPageLinkArrowContainer = styled.div`
  background-color: #fff;
  padding: 6px;
  border-radius: 40vw;
  height: 4.2vw;
  width: 4.2vw;
  box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
  float: right;
  display: flex;
  align-items: center;
`;

const NextPageLinkArrow = styled.div`
  width: 2vw;
  height: 2vw;
  background: transparent;
  border-top: .6vw solid #${props => props.color};
  border-right: .6vw solid #${props => props.color};
  -webkit-box-shadow: 0 0 0 #${props => props.color};
  box-shadow: 0 0 0 #${props => props.color};
  -webkit-transition: all 400ms ease;
  transition: all 400ms ease;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  border-radius: 0.1vw;
  margin: auto;
  margin-right: 1vw;
`;


const NextPageLinkMobile = ({ color, text, switchPages }) => (
  <NextPageLink color={color} onClick={switchPages}>
    <NextPageLinkText>
      {text}
    </NextPageLinkText>
    <NextPageLinkArrowContainer>
      <NextPageLinkArrow color={color} />
    </NextPageLinkArrowContainer>
  </NextPageLink>
);

export default NextPageLinkMobile;



// WEBPACK FOOTER //
// ./src/shared/NextPageLink/NextPageLinkMobile.js